export default {
  ACTK: "access_token",
  RFTK: "refresh_token",
  USER: "user",
  NAV: "nav-menu",
};
